import * as React from 'react';
import { SVGProps } from 'react';

const SvgRfq = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 86 86'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle
      cx={43}
      cy={43}
      r={42.446}
      fill='#0F2EFF'
      stroke='#0F2EFF'
      strokeWidth={1.108}
    />
    <rect
      x={13.063}
      y={20.683}
      width={59.873}
      height={38.101}
      rx={2}
      fill='#fff'
    />
    <path fill='#ECECEC' d='M13.063 22.861h30.481v34.835H13.063z' />
    <path fill='#C5C5C5' d='M35.924 58.785h15.241v4.354H35.924z' />
    <path fill='#D9D9D9' d='M30.481 63.139h26.127v2.177H30.481z' />
    <path fill='#3D3D3D' d='M55.519 54.43h6.532v2.177h-6.532z' />
    <g clipPath='url(#rfq_svg__a)'>
      <path
        d='m35.5 36.616-5.861-3.26a.507.507 0 0 0-.493 0l-5.861 3.26a.478.478 0 0 0-.178.17.45.45 0 0 0-.065.233v6.52a.45.45 0 0 0 .065.231c.043.07.104.13.178.17l5.861 3.26a.506.506 0 0 0 .493 0l5.861-3.26a.478.478 0 0 0 .178-.17.449.449 0 0 0 .065-.232v-6.52a.449.449 0 0 0-.065-.231.478.478 0 0 0-.178-.17Zm-6.108-2.318 4.893 2.72-4.893 2.721-4.892-2.72 4.892-2.721ZM24.02 37.83l4.885 2.716v5.441l-4.885-2.716V37.83Zm5.862 8.157v-5.441l4.885-2.716v5.44l-4.885 2.717Z'
        fill='#000'
      />
    </g>
    <path
      d='M13.063 22.86h59.874v-.177a2 2 0 0 0-2-2H15.063a2 2 0 0 0-2 2v.178Z'
      fill='#000'
    />
    <path
      d='M46.81 28.304h22.86M46.81 31.57h15.24'
      stroke='#646464'
      strokeLinecap='round'
    />
    <path fill='#3D3D3D' d='M13.063 22.861h2.177v34.835h-2.177z' />
    <path fill='#0F2EFF' d='M51.165 37.013h7.62v7.62h-7.62z' />
    <path fill='#ECECEC' d='M58.785 44.633h4.763v4.763h-4.763z' />
    <circle cx={63.547} cy={41.776} r={2.858} fill='#FFCB00' />
    <defs>
      <clipPath id='rfq_svg__a'>
        <path
          fill='#fff'
          transform='translate(21.772 32.658)'
          d='M0 0h15.241v15.241H0z'
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgRfq;
